import { erpAxios } from '.';

const getOrganizacijaRadnik = async (id) => {
  const { data } = await erpAxios.get(`/radnici/organizacija/${id}`);
  return data;
};

export default getOrganizacijaRadnik;
